import { connect } from 'react-redux';
import { toggleFeatureFlag } from 'reducers/featureFlags/actions';
import getFeatureFlags from 'selectors/getFeatureFlags';
import withFeatureFlags from 'hocs/withFeatureFlags';
import FeatureFlags from './FeatureFlags';

const mapStateToProps = state => {
  return {
    flags: getFeatureFlags(state),
  };
};

const mapDispatchToProps = {
  onToggle: toggleFeatureFlag,
};

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureFlags);

const mapFlagsToProps = flags => ({
  displayExample: flags.featureFlagPageExample,
});

export default withFeatureFlags(mapFlagsToProps)(connected);
